import { ApolloClient, InMemoryCache } from "@apollo/client";

const GRAPHQL_ENDPOINT =
  "https://g4hngea4jff63nikf5afadahlu.appsync-api.us-east-1.amazonaws.com/graphql";

export const client = new ApolloClient({
  uri: GRAPHQL_ENDPOINT,
  cache: new InMemoryCache(),
  headers: {
    "x-api-key": "da2-ofsckugubrhb3gn6rjqlzxanni",
  },
});
